import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { firstValueFrom, Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { BeneficiarioCriptomoneda } from '../../interfaces/beneficiario-criptomoneda.interface';
import { BinanceService } from '../../services/binance.service';
import { CartolaService } from '../../services/cartola.service';

import { Router } from '@angular/router';
import { ParametrosEnum } from 'src/app/shared/enums/parameters.enum';
import Swal from 'sweetalert2';
import { AutomaticRateService } from '../../services/automatic-rate.service';
import { HoursOperationService } from '../../services/hours-operation.service';
import { ParameterService } from '../../services/parameter.service';
import { EstadoTramosClpUsdtResponse, MainRatesService } from '../../services/main-rates.service';
import { mensajeEnvioIncierto } from '../convert-usdt-ves/convert-usdt-ves.rules';
import {
  clasificarErrorConversionClp,
  cotizarCompraClp,
  cotizarDesdeUsdt,
  CotizacionDesdeUsdt,
  TEXTO_SIN_TASA_CLP,
  TEXTO_TASA_CAMBIO_CLP,
  tramosCompraVigentes,
} from './clp-usdt.tramos';
import { EscalonVista } from '../home-rates/models/home-rates.model';
import { escaleraDesde, montoParaCorte } from '../home-rates/rules/home-rates.rules';
import { divisorParaTramo, precioCorteValido } from 'src/app/shared/utils/monto-usdt-tramo';
import { CalculatorCryptoComponent } from './components/calculator-crypto/calculator.component';
import {
  UsdtDestinationData,
  UsdtDestinationModalComponent,
  UsdtDestinationResult,
} from './components/usdt-destination-modal/usdt-destination-modal.component';

/**
 * Lo que acreditó el servidor en la conversión CLP→USDT a la billetera. El
 * servidor responde `conversion.{clpAmount, usdtAmount, rate}` con `rate` en
 * USDT por CLP (lo que viaja); acá se devuelve la tasa en CLP por USDT, la de
 * la pantalla. Campo ausente o inválido: el del formulario.
 */
export function acreditadoClpUsdt(
  conversion: { clpAmount?: unknown; usdtAmount?: unknown; rate?: unknown } | null | undefined,
  form: { clpAmount: number; usdtAmount: number; rate: number },
): { clp: number; usdt: number; tasa: number } {
  const pos = (v: unknown): number | null => {
    const n = Number(v);
    return v != null && Number.isFinite(n) && n > 0 ? n : null;
  };
  const rate = pos(conversion?.rate);
  return {
    clp: pos(conversion?.clpAmount) ?? form.clpAmount,
    usdt: pos(conversion?.usdtAmount) ?? form.usdtAmount,
    tasa: rate !== null ? 1 / rate : form.rate,
  };
}

@Component({
  selector: 'app-calculator-cryto',
  templateUrl: './calculator-cryto.component.html',
  styleUrls: ['./calculator-cryto.component.sass'],
})
export class CalculatorCrytoComponent implements OnInit {
  isVertical = false;
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    if (window.innerWidth <= 768) {
      this.isVertical = true;
    } else {
      this.isVertical = false;
    }
  }
  constructor(
    private cartolaService: CartolaService,
    private store: Store<AppState>,
    private binanceService: BinanceService,
    private actionService: ActionsService,
    private hourOperations: HoursOperationService,
    private router: Router,
    private automaticRateService: AutomaticRateService,
    private parameterService: ParameterService,
    private dialog: MatDialog,
    private mainRates: MainRatesService,
  ) {
    this.getCurrentValues();
    this.validarEstado();
  }

  @ViewChild('calculatorComponent') calculatorComponent:
    | CalculatorCryptoComponent
    | undefined;

  // Step management
  currentStep = 1;
  totalSteps = 3;
  slideDirection: 'left' | 'right' = 'left';
  isTransitioning = false;

  public subscription: Subscription = new Subscription();
  public user: any;
  public saldoActual = 0;
  public sobregiroDisponible: number | undefined = 0;
  public saldoContable: number | undefined = 0;
  public lineaCreditoBloqueada: boolean | undefined = false;
  public lineaCredito: number | undefined = 0;
  public hasLoaded: boolean = false;
  public usdt_clp_tax: number = 0;
  public aguacate_usdt_rate: number = 0;
  public stepPass2: boolean = false;
  public stepPass3: boolean = false;
  public stepPass4: boolean = false;
  public clpCurrency: number = 0;
  public usdCurrency: number = 0;
  public beneficiario: BeneficiarioCriptomoneda | undefined;
  public valorCambioId: number = 0;
  public currentValues: any;
  public aguacateUsdtRate: number = 0;
  public rateValues: any;
  public precioSpot: number = 0;
  public delta: number = 0;
  public startTime = new Date();
  estadoOperaciones = true;
  estadoStopOperacion = true;
  operationalPause = false;

  /**
   * Tramos CLP→USDT (22/10/2026), de `rates/tramos-usdt/clp-usdt`. Null si la
   * llamada falló (backend viejo, 404, 503): entonces la tasa se calcula
   * EXACTAMENTE como antes (`getSegmentationRate` sin tramos).
   */
  tramosClp: EstadoTramosClpUsdtResponse | null = null;
  /** Mejor tasa publicada («Desde X»); null si ningún tramo mejora la base. */
  desdeTasa: number | null = null;
  /** CLP ahorrados frente a la base con el monto actual (0 = no se muestra). */
  ahorroClp = 0;
  /**
   * Escalera de tramos para `app-escalera-tramos` (presentación). Null si no
   * hay tramos, si son de otra fila base o si todos cobran lo mismo: la
   * pantalla queda como antes.
   */
  escaleraClp: EscalonVista[] | null = null;

  ngOnInit(): void {
    this.onWindowResize();
    this.subscription.add(
      this.store.select('auth').subscribe(({ user }: any) => {
        this.user = user;
        if (!user || !user.segmentacionId) {
        } else {
          this.getCurrentValues();
        }
        this.obtenerSaldo();
      }),
    );
    this.subscription.add(
      this.actionService.subjectTasaUSDT.subscribe((res) => {
        this.getCurrentValues();
        if (this.currentStep !== 1) {
          Swal.fire(
            'Tasas actualizadas',
            'Se han actualizado las tasas, será regresado al primer paso',
            'warning',
          ).then(() => {});
          this.currentStep = 1;
        }
      }),
    );
  }

  async validarEstado() {
    this.estadoOperaciones =
      await this.hourOperations.getEstadoOperacion('USDT');
    this.estadoStopOperacion =
      await this.hourOperations.getEstadoOperacion('USDT_STOP');
    this.operationalPause = await this.parameterService.getParameter(
      ParametrosEnum.PAUSA_OPERACIONAL,
    );
    await this.parameterService
      .getParameter(ParametrosEnum.PAUSA_OPERACIONAL)
      .then((value) => {
        this.operationalPause = value.valor;
      });
    const message =
      'Hemos cerrado operaciones, muchas gracias por preferirnos.';
    const messageStop = this.operationalPause
      ? 'Por motivos operativos, el sistema estará en pausa durante 10 minutos. Por favor, intenta nuevamente después de las 20:01 ¡Gracias por tu comprensión!'
      : 'Por motivos operativos, el sistema estará en pausa durante 10 minutos.';
    if (!this.estadoOperaciones) {
      Swal.fire({
        confirmButtonColor: '#1e5a3f',
        title: 'Operación cerrada',
        text: message,
      });
      this.router.navigate(['/wallet']);
    }
    if (!this.estadoStopOperacion) {
      Swal.fire({
        confirmButtonColor: '#1e5a3f',
        title: 'Operación Pausada',
        text: messageStop,
      });
      this.router.navigate(['/wallet']);
    }
  }

  /**
   * 30/10/2026: se le pasa al resumen para volver a consultar el canal justo
   * antes de confirmar. `validarEstado` avisa y saca al cliente si está cerrado
   * o en pausa. Si la consulta falla no se bloquea, igual que al entrar.
   */
  operacionSigueAbierta = async (): Promise<boolean> => {
    try {
      await this.validarEstado();
    } catch {
      return true;
    }
    return !!this.estadoOperaciones && !!this.estadoStopOperacion;
  };

  async obtenerSaldo() {
    if (this.user?.usuarioId) {
      const {
        saldo,
        lineaCreditoId,
        balancePermitido,
        lineaBloqueada,
        sobregiro,
      } = await this.cartolaService.getSaldoCliente(this.user.usuarioId);
      this.saldoActual = saldo;
      this.sobregiroDisponible = sobregiro;
      this.saldoContable = balancePermitido;
      this.lineaCreditoBloqueada = lineaBloqueada;
      this.lineaCredito = lineaCreditoId;
    }
  }

  async getCurrentValues() {
    // La tasa de siempre y los tramos en paralelo. Los tramos nunca frenan ni
    // rompen la pantalla: si fallan, null y se cotiza como antes.
    const [rateValues, tramos] = await Promise.all([
      this.automaticRateService.getUsdtRateForUser(),
      this.leerTramosClp(),
    ]);
    this.rateValues = rateValues;
    this.tramosClp = tramos;
    this.currentValues = this.rateValues.valoresCambio;
    this.aguacateUsdtRate = this.currentValues.tasaUsdtClp;
    this.precioSpot = +this.rateValues.spot.valor;
    this.delta = Math.round(+this.rateValues.delta * 100) / 100;
    this.valorCambioId = this.currentValues.id;
    this.getSegmentationRate();
    this.escaleraClp = this.armarEscaleraClp();
  }

  /** Base con la que el back elige el tramo de compra (`montoClp ÷ base`). */
  get baseTramosClp(): number {
    return +this.aguacateUsdtRate || 0;
  }

  /**
   * `precioCorte` del GET de tramos (23/10): con él el back elige el tramo
   * (`montoClp ÷ precioCorte`, el spot). Null si no viene o no es válido: la
   * escalera divide por la base, como hoy.
   */
  get precioCorteClp(): number | null {
    return precioCorteValido(this.tramosClp?.precioCorte);
  }

  /** Los tramos que valen para esta fila base, en la forma de la escalera. */
  private armarEscaleraClp(): EscalonVista[] | null {
    if (!this.tramosClp || !(+this.aguacateUsdtRate > 0)) return null;
    return escaleraDesde(
      tramosCompraVigentes(this.tramosClp, this.valorCambioId).map((t) => ({
        desde: Number(t.desde),
        tasa: Number(t.tasa),
      })),
      { unidadCorte: 'USDT', monedaMonto: 'CLP', tipoAhorro: 'PAGA_MENOS', exigirMejora: true },
    );
  }

  /** Tramos CLP→USDT; null si la llamada falla o el servicio no la tiene. Nunca lanza. */
  private async leerTramosClp(): Promise<EstadoTramosClpUsdtResponse | null> {
    try {
      return (await firstValueFrom(this.mainRates.obtenerTramosClpUsdt())) ?? null;
    } catch {
      return null;
    }
  }

  getSegmentationRate() {
    const c = this.cotizarClp(+this.clpCurrency || 0);
    this.usdt_clp_tax = c.tasa;
    this.desdeTasa = c.desde;
    this.ahorroClp = c.ahorroClp;
  }

  /**
   * La tasa que se cobra por `clp` pesos, sin tocar la pantalla. Es la cuenta
   * de siempre (segmentación o base, al centavo) y, con tramos (la llamada
   * respondió), `min(tramo del monto o base, max(segmentación, piso))`, igual
   * que el servidor. Sin tramos queda la de siempre.
   */
  private cotizarClp(clp: number): { tasa: number; desde: number | null; ahorroClp: number } {
    let tasa: number;
    let segmentada: number | null = null;
    if (this.user?.segmentacionId === 1) {
      tasa = this.calculateUsdtClpRate();
    } else {
      if (this.user?.minimumTresholdUsdt < clp) {
        tasa = +this.user?.segmentacionUsdtRate + +this.precioSpot;
        segmentada = Math.round(tasa * 100) / 100;
      } else {
        tasa = this.calculateUsdtClpRate();
      }
    }
    tasa = Math.round(tasa * 100) / 100;
    const sinTramo = { tasa, desde: null, ahorroClp: 0 };
    const base = +this.aguacateUsdtRate;
    // 25/10/2026: si falló la llamada de tramos, un segmentado mandaba su tasa
    // cruda y la lambda cobra max(cliente, esperada): con recargo (seg > base)
    // pagaba de más. La segmentación solo beneficia: se manda min(base, seg).
    // Sin tramos no se conoce `pisoSegmentacion`; el servidor recorta igual.
    if (!this.tramosClp && segmentada !== null && base > 0) {
      return { ...sinTramo, tasa: Math.round(Math.min(base, segmentada) * 100) / 100 };
    }
    if (!this.tramosClp || !(base > 0)) return sinTramo;
    const c = cotizarCompraClp({
      data: this.tramosClp,
      montoClp: clp,
      base,
      valorCambioId: this.valorCambioId,
      segmentada,
    });
    if (!(c.tasa > 0)) return sinTramo;
    return { tasa: Math.round(c.tasa * 100) / 100, desde: c.desde, ahorroClp: c.ahorroClp };
  }

  /**
   * Monto escrito en USDT (con tramos). El tramo se elige con los PESOS
   * (`clp ÷ base`), así que `clp = usdt × tasaDelTramo` puede caer en otro
   * tramo y acreditar menos de lo escrito (1001 USDT → 1000,81). Se busca la
   * tasa por punto fijo y, si no hay, se sube el CLP al primer peso del tramo
   * (ver `cotizarDesdeUsdt`). Null sin tramos: la calculadora hace lo de hoy.
   */
  readonly cotizarUsdt = (usdt: number): CotizacionDesdeUsdt | null => {
    const base = +this.aguacateUsdtRate;
    if (!this.tramosClp || !(base > 0)) return null;
    // Los pesos de cada corte con el mismo divisor que elige el tramo (`precioCorte` o la base).
    const divisor = divisorParaTramo(this.tramosClp.precioCorte, base);
    const cortes = tramosCompraVigentes(this.tramosClp, this.valorCambioId).map((t) =>
      montoParaCorte(Number(t.desde), 'CLP', 'USDT', divisor),
    );
    // La segmentación también parte la cuenta: rige con `clp > umbral`.
    const umbral = Number(this.user?.minimumTresholdUsdt);
    if (this.user?.segmentacionId !== 1 && Number.isFinite(umbral) && umbral >= 0) {
      cortes.push(Math.floor(umbral) + 1);
    }
    return cotizarDesdeUsdt(usdt, (clp) => this.cotizarClp(clp).tasa, cortes);
  };

  calculateUsdtClpRate(): number {
    // if (this.clpCurrency < 5000000) {
    //   return this.aguacateUsdtRate;
    // }
    // if (this.clpCurrency <= 10000000) {
    //   return this.precioSpot + 0.97 * this.delta;
    // }
    // if (this.clpCurrency <= 15000000) {
    //   return this.precioSpot + 0.94 * this.delta;
    // }
    // if (this.clpCurrency <= 20000000) {
    //   return this.precioSpot + 0.91 * this.delta;
    // }
    // if (this.clpCurrency <= 25000000) {
    //   return this.precioSpot + 0.88 * this.delta;
    // }
    // if (this.clpCurrency <= 30000000) {
    //   return this.precioSpot + 0.85 * this.delta;
    // }
    // if (this.clpCurrency <= 35000000) {
    //   return this.precioSpot + 0.82 * this.delta;
    // }
    // if (this.clpCurrency <= 40000000) {
    //   return this.precioSpot + 0.79 * this.delta;
    // }
    // if (this.clpCurrency > 40000000) {
    //   return this.precioSpot + 0.76 * this.delta;
    // }
    return this.aguacateUsdtRate;
  }

  async returngetCurrentTax() {
    if (!(this.startTime.getTime() + 60000 < new Date().getTime())) {
      return;
    }
    const currentValues = await this.binanceService.getConversionData();
    const precioSpotActual = await this.parameterService.getParameter(
      ParametrosEnum.PRECIO_SPOT,
    );
    const spotValidation =
      +precioSpotActual.valor > this.precioSpot + 0.2 && this.precioSpot != 0;
    if (
      (currentValues.tasaUsdtClp > this.aguacateUsdtRate + 0.2 &&
        this.aguacateUsdtRate != 0) ||
      spotValidation
    ) {
      this.getCurrentValues();
      this.startTime = new Date();
      if (this.currentStep !== 1) {
        Swal.fire(
          'Tasas actualizadas',
          'Se han actualizado las tasas, será regresado al primer paso',
          'warning',
        ).then(() => {});
        this.currentStep = 1;
        setTimeout(
          () => this.calculatorComponent!.transformCurrency('clp'),
          1000,
        );
      }
    }
  }

  async validateGetCurrentValues() {
    const currentValues = await this.binanceService.getConversionData();
    let last_tax = this.usdt_clp_tax;
    if (last_tax != currentValues.tasaUsdtClp) {
    }
    this.usdt_clp_tax = currentValues.tasaUsdtClp;
    this.valorCambioId = currentValues.id;
  }

  nextStep(step: number): void {
    switch (step) {
      case 2: {
        this.stepPass2 = true;
        break;
      }
      case 3: {
        this.stepPass3 = true;
        break;
      }
    }
    this.slideDirection = 'left';
    this.isTransitioning = true;
    setTimeout(() => {
      this.currentStep = step;
      this.isTransitioning = false;
    }, 100);
  }

  previousStep(): void {
    if (this.currentStep === 1) {
      this.router.navigate(['/wallet/client/cripto-home']);
      return;
    }
    this.slideDirection = 'right';
    this.isTransitioning = true;
    this.returngetCurrentTax();
    setTimeout(() => {
      this.currentStep--;
      this.isTransitioning = false;
    }, 100);
  }

  assignClp(clp: number) {
    this.clpCurrency = clp;
    this.getSegmentationRate();
    if (this.clpCurrency === 0) this.stepPass2 = false;
  }

  assignUsd(usd: number) {
    this.usdCurrency = usd;
    if (this.usdCurrency === 0) this.stepPass2 = false;
  }

  assignBeneficiario(beneficiario: BeneficiarioCriptomoneda) {
    this.beneficiario = beneficiario;
  }

  /**
   * Maneja el clic en el botón "Comprar" - abre modal de selección de destino
   */
  onBuyClicked(data: {
    clpAmount: number;
    usdtAmount: number;
    rate: number;
  }): void {
    const dialogData: UsdtDestinationData = {
      clpAmount: data.clpAmount,
      usdtAmount: data.usdtAmount,
      rate: data.rate,
    };

    const dialogRef = this.dialog.open(UsdtDestinationModalComponent, {
      data: dialogData,
      panelClass: 'usdt-destination-dialog',
      maxWidth: '100vw',
      width: this.isVertical ? '100vw' : '520px',
      height: 'auto',
      disableClose: false,
    });

    dialogRef
      .afterClosed()
      .subscribe((result: UsdtDestinationResult | null) => {
        if (!result) {
          // Usuario canceló
          return;
        }

        if (result.destination === 'wallet') {
          // Guardar en wallet Aguacate - llamar al servicio de conversión
          this.processWalletConversion(result.data);
        } else {
          // Retirar inmediatamente - continuar con el flujo actual (paso 2)
          this.proceedToWithdrawFlow();
        }
      });
  }

  /**
   * Procesa la conversión CLP a USDT y guarda en wallet
   */
  private async processWalletConversion(
    data: UsdtDestinationData,
  ): Promise<void> {
    try {
      Swal.fire({
        title: 'Procesando conversión',
        text: 'Por favor espera mientras procesamos tu solicitud...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const usdtRate = 1 / data.rate; // Convertir tasa CLP/USDT a USDT/CLP
      // Con el error real (`errorHttpReal`): un 400 «La tasa cambió…» se
      // recotiza y un 503 dice que no hay tasa, en vez de «No autorizado».
      const response = await this.binanceService.convertClpToUsdtConErrorReal(
        this.user.usuarioId.toString(),
        data.clpAmount,
        usdtRate,
        data.usdtAmount,
      );

      if (response.success) {
        // Lo que ACREDITÓ el servidor (puede liquidar con su tasa), no lo del
        // formulario. Sin esos campos (backend viejo), lo del formulario.
        const acreditado = acreditadoClpUsdt(response?.conversion, data);
        // Mostrar mensaje de éxito con timer de 3 segundos
        Swal.fire({
          icon: 'success',
          title: '¡Conversión exitosa!',
          html: `
            <div style="text-align: left; padding: 10px;">
              <p><strong>Has convertido:</strong></p>
              <p style="font-size: 1.1em; color: #1e5a3f;">
                ${this.formatCLP(acreditado.clp)} CLP → ${this.formatUSDT(acreditado.usdt)}
              </p>
              <p style="margin-top: 6px; font-size: 0.9em; color: #374151;">
                Tasa: ${this.formatTasaClp(acreditado.tasa)} CLP por USDT
              </p>
              <p style="margin-top: 15px;"><strong>Nuevo saldo USDT:</strong></p>
              <p style="font-size: 1.2em; color: #1e5a3f; font-weight: bold;">
                ${this.formatUSDT(response.conversion.newUsdtBalance)}
              </p>
              <p style="margin-top: 15px; font-size: 0.9em; color: #666;">
                Tus USDT están disponibles en tu Wallet Aguacate
              </p>
              <p style="margin-top: 10px; font-size: 0.85em; color: #999;">
                Redirigiendo al inicio...
              </p>
            </div>
          `,
          timer: 5000,
          timerProgressBar: true,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          // Redirigir a home después de 3 segundos
          this.router.navigate(['/wallet']);
        });
      }
    } catch (error: any) {
      Swal.close();
      await this.avisarErrorConversion(error);
    }
  }

  /**
   * Error de la conversión a la billetera, ya traducido por `errorHttpReal`
   * (`{ status, message, transitorio }`). Ver `clasificarErrorConversionClp`.
   */
  private async avisarErrorConversion(error: any): Promise<void> {
    const tipo = clasificarErrorConversionClp(error);
    if (tipo === 'TASA_CAMBIO') {
      // No se hizo nada: se recotiza con la tasa y los tramos nuevos.
      await this.getCurrentValues();
      this.calculatorComponent?.transformCurrency('clp');
      await Swal.fire({
        icon: 'warning',
        title: 'La tasa cambió',
        text: TEXTO_TASA_CAMBIO_CLP,
        confirmButtonColor: '#1e5a3f',
      });
      return;
    }
    if (tipo === 'SIN_TASA') {
      await Swal.fire({
        icon: 'error',
        title: 'Sin tasa disponible',
        text: TEXTO_SIN_TASA_CLP,
        confirmButtonColor: '#1e5a3f',
      });
      return;
    }
    if (tipo === 'INCIERTO') {
      // Pudo haberse hecho: no se ofrece reintentar desde aquí.
      await Swal.fire({
        icon: 'warning',
        title: 'No pudimos confirmar la conversión',
        text: mensajeEnvioIncierto('wallet'),
        confirmButtonColor: '#1e5a3f',
      });
      this.router.navigate(['/wallet']);
      return;
    }
    await Swal.fire({
      icon: 'error',
      title: 'Error en la conversión',
      text: error?.message || error?.error?.message || 'Ocurrió un error al procesar la conversión',
      confirmButtonColor: '#1e5a3f',
    });
  }

  /**
   * Continúa con el flujo de retiro (paso 2 - selección de beneficiario)
   */
  private proceedToWithdrawFlow(): void {
    this.nextStep(2);
  }

  private formatCLP(value: number): string {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  /** CLP por USDT, en el formato del modal (el de `formatUSDT`). */
  private formatTasaClp(value: number): string {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  private formatUSDT(value: number): string {
    return (
      new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) + ' USDT'
    );
  }
}
